import { render, staticRenderFns } from "./teacherViewQuestion.vue?vue&type=template&id=11e17e14&"
import script from "./teacherViewQuestion.vue?vue&type=script&lang=js&"
export * from "./teacherViewQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports